import { goalsService } from 'src/config/rootService';

import { GoalCategoryWithSubcategories } from '../models/goals';

export type GoalsCategoriesState = GoalCategoryWithSubcategories[];

const defaultState: GoalsCategoriesState = [];

export const goalCategories = {
    state: defaultState,
    reducers: {
        saveCategories: (
            _state,
            payload: GoalCategoryWithSubcategories[] = [],
        ): GoalsCategoriesState => payload,
    },
    effects: dispatch => ({
        async fetchGoalsCategories(): Promise<void> {
            const categories = await goalsService.fetchGoalsCategories();

            dispatch.goalCategories.saveCategories(categories);
        },
    }),
};
